import React, { useState, useCallback, useEffect } from "react";
import { Image } from '@fluentui/react';
import {AppMenu} from "./AppMenu";


interface OrderManagementProps {}

interface OrderManagementState {}

const OrderManagement: React.FC<OrderManagementProps> = ({}) => {           
    const [pageState, setPageState] = useState<OrderManagementState>(() => {});

    return(
        <>
                                    <div style={{width: "100%", textAlign: "left"}}>
                                        <AppMenu/>
                                    </div>
                                    <div key={'OM1'} style={{ 
                                    flex: '1 1 calc(100% - 40px)',
                                    minWidth: '250px',
                                    height: '530px',
                                    background: 'white',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    overflow: 'hidden'
                                  }}>
                                    <div style={{ 
                                      padding: '15px', 
                                      borderBottom: '0px solid #e1e1e1',
                                      background: '#ffffff',
                                      fontWeight: 600,
                                      color: '#323130'
                                    }}>
                                      Order Management
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                       <div className="card-grey">         
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <div style={{  gap: '8px', letterSpacing: '0.02em', fontSize: '0.95rem' }}>Balanced supplier relationships are important for businesses to face long-term and short-term uncertainties in markets. This spans from strategic partners to short-term suppliers. Companies face challenges in obtaining right information related to goods and services especially when the processes are complex. eSDXG's AI based Order Management and assisted execution helps business to gain productivity in RFI & RFQ processes, auto drafting the order items and selection of suppliers.</div>
                                                <Image src="ordermanagement.png" alt="Order Management" style={{ width: '450px', height: '350px', objectFit: 'scale-down' }} />
                                            </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
    );
}

export default OrderManagement; 
